import React, { ComponentType } from 'react';
import { components, DropdownIndicatorProps } from 'react-select';
import { SelectArrow } from '@lt/components/icons-react/userflow';

import { DepartureOption } from '@lt/api/dist/types/departure';

export const DropdownIndicator: ComponentType<DropdownIndicatorProps<DepartureOption, false>> = (
  props
) => (
  <components.DropdownIndicator {...props}>
    <SelectArrow width="10px" />
  </components.DropdownIndicator>
);
